/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */

import { gql } from '@apollo/client'

import { DISPLAY_SNAPSHOT_IMAGE_FRAGMENT } from './DisplaySnapshotImageFragment'
import { LOCATION_FRAGMENT } from './LocationFragment'
import { USER_FRAGMENT } from './UserFragment'

export const DISPLAY_SNAPSHOT_WITH_IMAGE_BOXES_FRAGMENT = gql`
  fragment DisplaySnapshotWithImageBoxes on DisplaySnapshot {
    id
    created
    captureTime
    type
    display {
      id
      name
      store {
        id
        location {
          ...Location
        }
      }
    }
    user {
      ...User
    }
    emptyFacings {
      id
      upc
    }
    images {
      ...DisplaySnapshotImage
    }
    planogramSegmentShapedFacings {
      id
      upc
    }
  }
  ${LOCATION_FRAGMENT}
  ${USER_FRAGMENT}
  ${DISPLAY_SNAPSHOT_IMAGE_FRAGMENT}
`
